import React, { forwardRef, useRef, useState, useEffect } from 'react'
import SwalAlert from '../../../services/swalService/SwalService';
import CardSection from '../../../components/ui/card/CardSection';
import SearchBar from '../../../components/ui/searchBar/SearchBar';
import Buttons from '../../../components/ui/button/Buttons';
import MolGrid from '../../../components/grid/MolGrid';
import CenterModel from '../../../components/ui/centerModel/CenterModel';
import { useDeleteTeamProjectMutation, useGetAllTeamProjectListMutation } from '../../../app/services/teamProjectsAPI';
import { TeamProjectGridConfig } from './TeamProjects/TeamProjects.Data';
import AddEditTeamProjects from './TeamProjects/AddEditTeamProjects';
import ToastService from '../../../services/toastService/ToastService';
import "../../teams/Teams.scss";
import useDebounce from '../../../app/customHooks/useDebounce';

const TeamProjects = forwardRef((props, ref) => {

  const [searchText, setSearchText] = useState("");
  const molGridRef = useRef();
  const [TeamProjectGridData, setTeamProjectGridData] = useState();
  const [totalRowCount, setTotalRowCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [showModal, setShowModal] = useState(false);
  const { confirm } = SwalAlert();
  const teamId = props.teamId;
  const debouncedSearch = useDebounce(searchText, 300);

  const [
    deleteTeamProject,
    { isSuccess: isTeamProjectDeleted, data: deleteTeamProjectData },
  ] = useDeleteTeamProjectMutation();

  const [getAllTeamProjectList, {
    isLoading: isTeamProjectListLoading,
    isSuccess: isTeamProjectListSuccess,
    data: isTeamProjectListData,
  },] = useGetAllTeamProjectListMutation();

  useEffect(() => {
    if (isTeamProjectListSuccess && isTeamProjectListData) {
      if (isTeamProjectListData) {
        setTeamProjectGridData(isTeamProjectListData.dataSource);
      }
      if (isTeamProjectListData.totalRecord) {
        setTotalRowCount(isTeamProjectListData.totalRecord);
      }
    }
  }, [isTeamProjectListSuccess, isTeamProjectListData]);

  useEffect(() => {
    if (molGridRef.current) {
      let currentPageObject = molGridRef.current.getCurrentPageObject();
      const request = {
        pagination: {
          pageNumber:currentPageObject?.pageNumber,
          pageSize:currentPageObject?.pageSize
        },
        filters: { searchText: debouncedSearch },
      };
      getProjectDataList(request);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedSearch]);

  const AddhandleToggleModal = () => {
    setShowModal(!showModal);
    if (molGridRef.current) {
      const currentPageObject = molGridRef.current.getCurrentPageObject();
      const request = {
        pagination: {
          pageNumber: currentPageObject.pageNumber,
          pageSize: currentPageObject.pageSize,
        },
        filters: { searchText: debouncedSearch },
      };
      getProjectDataList(request);
    }
  };

  const onDeleteClick = (data) => {
    confirm(
      "Delete?",
      "Are you sure you want to Delete?",
      "Delete",
      "Cancel"
    ).then((confirmed) => {
      if (confirmed) {
        deleteTeamProject(data.teamProjectId);
      }
    });
  };

  useEffect(() => {
    if (isTeamProjectDeleted && deleteTeamProjectData) {
      const currentPageObject = molGridRef.current.getCurrentPageObject();
      ToastService.success(deleteTeamProjectData.errorMessage);
      const request = {
        pagination: {
          pageNumber: currentPageObject.pageNumber,
          pageSize: currentPageObject.pageSize,
        },
        filters: { searchText: debouncedSearch },
      };
      getProjectDataList(request);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isTeamProjectDeleted, deleteTeamProjectData]);


  const handlePageChange = (page) => {
    const newPage = page.pageNumber || page;
    const newPageSize = page.pageSize || pageSize;

    setCurrentPage(newPage);
    setPageSize(newPageSize);
    const request = {
      pagination: {
        pageNumber: newPage,
        pageSize:newPageSize,
      },
      filters: { searchText: debouncedSearch },
    };
    getProjectDataList(request)
  };

  const handleOnSearchChange = (e) => {
    let value = e.target.value;
    setSearchText(value);
  };

  const getProjectDataList = (pageObject) => {
    const request = {
      pagination: {
        pageNumber: pageObject.pagination.pageNumber,
        pageSize: pageObject.pagination.pageSize,
      },
      filters: {
        searchText: debouncedSearch,
      },
      teamId: teamId,
    };
    getAllTeamProjectList(request);
  };


  const actionHandler = {
    ADD: AddhandleToggleModal,
    DELETE: onDeleteClick,
  };

  return (
    <div className="blue-bg-section">
      <div className="team-Projects">
        {/* Filter Section Start */}
        <div className="main-filter-section">
          <CardSection>
            <div className="filter-shorting-sec">
              <div className="search-input">
                <SearchBar
                  searchText="Search Project Name"
                  handleChange={handleOnSearchChange}
                />
              </div>
              <div className="right-side-section">
                <div className="add-btn">
                  <Buttons
                    buttonTypeClassName="theme-btn"
                    onClick={AddhandleToggleModal}
                    buttonText="Team Project"
                    textWithIcon={true}
                    iconName="material-symbols:add-rounded"
                    fontIcon={true}
                  />
                </div>
              </div>
            </div>
          </CardSection>
        </div>
        {/* Filter Section End */}
        <div className="table-grid">
          <div className="project-list team-project-grid">
            <CardSection isContentLoading={isTeamProjectListLoading}>
              <MolGrid
                ref={molGridRef}
                configuration={TeamProjectGridConfig}
                dataSource={TeamProjectGridData}
                isLoading={isTeamProjectListLoading}
                allowPagination={true}
                pagination={{
                  totalCount: totalRowCount,
                  pageSize: pageSize,
                  currentPage: currentPage,
                }}
                onPageChange={handlePageChange}
                onActionChange={actionHandler}
              />
            </CardSection>
          </div>
        </div>
      </div>
      <div>
        {showModal && (
          <CenterModel
            showModal={showModal}
            handleToggleModal={AddhandleToggleModal}
            modalTitle="Add Team Project"
            modelSizeClass="w-40"
          >
            <AddEditTeamProjects onClose={AddhandleToggleModal} />
          </CenterModel>
        )}
      </div>
    </div>
  )
});

export default TeamProjects;
